<template>
  <div>
    <div v-if="
      filter.type === FILTER_TYPE.LIST && filter.values.length > 0
    ">
      <ul>
        <li v-for="(filterItem, i) in filter.values" :key="i" @click="selectFilter(filterItem)" class="check-box-wrapper">
          <input type="checkbox" :id="`checkbox-${filter.id}-${filterItem.id}`" :value="filterItem.value"
            :checked="filter.selectedValues.includes(filterItem.value)" class="check-box check-box--no-tik">

          <label class="w-100" :for="filterItem.id">
            {{ filterItem.title }}
          </label>
        </li>
      </ul>
    </div>

    <div v-if="filter.type === FILTER_TYPE.RANGE">
      <FilterItemRange :filter="filter" />
    </div>
  </div>
</template>

<script>
import FilterItemRange from "./FilterItemRange";
import { mapActions } from "vuex";
import { FILTER_TYPE } from '@/constantData'

export default {
  name: "FilterItem",

  props: ["filter", "selectedValues"],

  components: {
    FilterItemRange,
  },

  data() {
    return {
      FILTER_TYPE
    };
  },

  methods: {
    ...mapActions({
      onChangeFilter: "onChangeFilter",
    }),

    selectFilter(selectedFilterItem) {
      this.onChangeFilter({
        filter: this.filter,
        filterItem: selectedFilterItem,
      })
    },
  }
};
</script>
